export default "__VITE_ASSET__BMuGlm0N__"